import { PartialType } from '../../../utils';
import { CreateFeeGradeDto } from './create-fee-grade.dto';
export class UpdateFeeGradeDto extends PartialType(CreateFeeGradeDto) {
}
